import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import {
  useSetTheme,
  useTheme,
} from '../context/Theme';

import jingmuLogoMarkup
  from './jingmuLogoMarkup';


const NAV_ITEMS = [

  {
    label: '主页',
    href: 'https://api.hzjingmu.cn/',
  },

  {
    label: '控制台',
    href: 'https://api.hzjingmu.cn/dashboard/overview',
  },

  {
    label: '模型广场',
    href: 'https://api.hzjingmu.cn/pricing',
  },

  {
    label: '文档',
    href: 'https://api.hzjingmu.cn/docs/',
  },

  {
    label: '令牌额度查询',
    href: 'https://api.hzjingmu.cn/key/',
    current: true,
  },

];


const THEME_ITEMS = [

  {
    id: 'wood',
    name: '原木生态',
    desc: '年轮 · 暖金 · 木纹',
  },

  {
    id: 'minimal',
    name: '简约科技',
    desc: 'Blueprint · 网格 · 蓝线',
  },

  {
    id: 'cyber',
    name: '炫酷科技',
    desc: 'Aurora · 光谱 · 霓虹',
  },

  {
    id: 'mono',
    name: '纯色简约',
    desc: '黑白 · 结构线 · 克制',
  },

  {
    id: 'club',
    name: '鲸木 CLUB · 黑白红',
    desc: '红金 · 准星 · 指令感',
  },

];


export default function JingmuHeader() {

  const theme =
    useTheme();

  const setTheme =
    useSetTheme();

  const [
    themeOpen,
    setThemeOpen
  ] = useState(false);

  const [
    mobileOpen,
    setMobileOpen
  ] = useState(false);

  const themeWrap =
    useRef(null);


  const logoHtml =
    useMemo(() => {

      return jingmuLogoMarkup.replace(
        /data-render="[^"]*"/,
        `data-render="${theme}"`
      );

    }, [theme]);


  useEffect(() => {

    function outside(e) {

      if (
        themeWrap.current &&
        !themeWrap.current.contains(
          e.target
        )
      ) {

        setThemeOpen(false);

      }

    }

    document.addEventListener(
      'click',
      outside
    );

    return () =>
      document.removeEventListener(
        'click',
        outside
      );

  }, []);


  useEffect(() => {

    document.body.classList.toggle(
      'jm-nav-open',
      mobileOpen
    );

    return () => {
      document.body.classList.remove(
        'jm-nav-open'
      );
    };

  }, [mobileOpen]);


  useEffect(() => {

    function hotkey(e) {

      if (
        e.ctrlKey ||
        e.altKey ||
        e.metaKey
      ) {
        return;
      }

      const tag =
        document.activeElement
          ?.tagName;

      if (
        tag === 'INPUT' ||
        tag === 'TEXTAREA'
      ) {
        return;
      }

      const map = {
        '1': 'wood',
        '2': 'minimal',
        '3': 'cyber',
        '4': 'mono',
        '5': 'club',
      };

      if (map[e.key]) {

        setTheme(
          map[e.key]
        );

      }

    }

    window.addEventListener(
      'keydown',
      hotkey
    );

    return () =>
      window.removeEventListener(
        'keydown',
        hotkey
      );

  }, [setTheme]);


  return (
    <>

      <header className="jm-site-header">

        <div className="jm-wrap jm-nav">

          <a
            className="jm-brand"
            href="https://api.hzjingmu.cn/"
            aria-label="鲸木 API 首页"
          >

            <span
              className="jm-inline-logo"
              dangerouslySetInnerHTML={{
                __html: logoHtml,
              }}
            />

            <span className="jm-brand-copy">

              <b>鲸木 API</b>

              <span>
                JINGMU · AI GATEWAY
              </span>

            </span>

          </a>


          <div className="jm-nav-actions">

            <nav
              className="jm-main-nav"
              aria-label="主导航"
            >

              {NAV_ITEMS.map(
                item => (

                  <a
                    key={item.href}
                    href={item.href}
                    className={
                      'jm-nav-link' +
                      (
                        item.current
                        ? ' is-current'
                        : ''
                      )
                    }
                    aria-current={
                      item.current
                      ? 'page'
                      : undefined
                    }
                  >

                    {item.label}

                  </a>

                )
              )}

            </nav>


            <button
              type="button"
              className="jm-mobile-trigger"
              aria-label="导航菜单"
              aria-expanded={mobileOpen}
              onClick={() =>
                setMobileOpen(
                  value => !value
                )
              }
            >

              <span />
              <span />

            </button>


            <div
              className="jm-theme-wrap"
              ref={themeWrap}
            >

              <button
                type="button"
                className="jm-theme-trigger"
                aria-expanded={themeOpen}
                onClick={e => {

                  e.stopPropagation();

                  setThemeOpen(
                    value => !value
                  );

                }}
              >

                <i />

                <span className="jm-theme-label">
                  风格
                </span>

                <span className="jm-theme-arrow">
                  ⌄
                </span>

              </button>


              <div
                className={
                  'jm-theme-menu' +
                  (
                    themeOpen
                    ? ' open'
                    : ''
                  )
                }
              >

                <div className="jm-theme-title">
                  VISUAL SYSTEM ·
                  1 / 2 / 3 / 4 / 5
                </div>

                <div className="jm-theme-grid">

                  {THEME_ITEMS.map(
                    item => (

                      <button
                        type="button"
                        key={item.id}
                        className={
                          'jm-theme-option' +
                          (
                            theme === item.id
                            ? ' active'
                            : ''
                          )
                        }
                        onClick={() => {

                          setTheme(
                            item.id
                          );

                          setThemeOpen(
                            false
                          );

                        }}
                      >

                        <strong>
                          {item.name}
                        </strong>

                        <small>
                          {item.desc}
                        </small>

                      </button>

                    )
                  )}

                </div>

              </div>

            </div>


            <a
              className="jm-console-btn"
              href="https://api.hzjingmu.cn/dashboard/overview"
            >

              控制台 →

            </a>

          </div>

        </div>

      </header>


      <div
        className={
          'jm-mobile-backdrop' +
          (
            mobileOpen
            ? ' open'
            : ''
          )
        }
        onClick={() =>
          setMobileOpen(false)
        }
      />


      <aside
        className={
          'jm-mobile-drawer' +
          (
            mobileOpen
            ? ' open'
            : ''
          )
        }
      >

        <div className="jm-mobile-head">

          <span>
            JINGMU · NAVIGATION
          </span>

          <button
            type="button"
            onClick={() =>
              setMobileOpen(false)
            }
          >
            ×
          </button>

        </div>


        <nav>

          {NAV_ITEMS.map(
            (item, index) => (

              <a
                href={item.href}
                key={item.href}
                className={
                  item.current
                  ? 'is-current'
                  : ''
                }
              >

                <small>
                  0{index + 1}
                </small>

                <b>
                  {item.label}
                </b>

                <i>→</i>

              </a>

            )
          )}

        </nav>

      </aside>

    </>
  );
}
